import { CountryState } from '../interfaces/country-state';
import { BaseModel } from './base.model';

export class Country extends BaseModel {
  public isoCode: string;
  public label: string;
  public states: CountryState[] = [];

  constructor(data) {
    super(data);
    if (data.states) {
      this.states = data.states;
    }
  }
}
